import React, { Fragment } from 'react';
import type { RouteComponentProps } from 'react-router-dom';

import { MobileTopMenu } from 'views/top-menu';
import { ListHelmet } from 'components';
import { AsyncMobileFilters } from 'modules/filters/async';
import { AsyncOutrightsList } from 'modules/outright/async';
import useOutrights from './useOutrights';

type Props = RouteComponentProps<any>;

const Outrights: React.FC<Props> = () => {
    const { isCompact, fetchStatus } = useOutrights();

    return (
        <Fragment>
            {isCompact && (
                <Fragment>
                    <MobileTopMenu fetchStatus={fetchStatus} />
                    <AsyncMobileFilters />
                </Fragment>
            )}
            <ListHelmet />
            <AsyncOutrightsList />
        </Fragment>
    );
};

export default Outrights;
